import { render, staticRenderFns } from "./BdAuthWorkWorkInternal.vue?vue&type=template&id=555a63ba&"
import script from "./BdAuthWorkWorkInternal.vue?vue&type=script&lang=js&"
export * from "./BdAuthWorkWorkInternal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports